export default __webpack_public_path__ + "static/media/popup_251114_2.c182d59e.png";